<div class="pasoPago">
  <div class="tituloInt tituloVentas">{{ 'DETALLES_DE_PAGO' | translate }}</div>
  <div class="onoffswitch-wrapGeneral">
  </div>
  <div class="InputsWrap" [formGroup]="pagosForm">
    <div class="pagoRow readonly empty" *ngIf="verPrepago ">
      <div class="tit-form-group">{{ 'PREPAGO' | translate }}</div>
      <div class="form-group-wrap">
        <div class="form-group">
      <input
        type="text"
        #prepagoInput
        formControlName="prepago"
        [value]="prepagoInput.value| myCurrency: divisaSimboloDecimal : divisaDecimales : divisaPosicion : divisaSimbolo : divisaSimboloDerecha : divisaSimbSeparacionMiles"
        class="form-control readonly"
        category="DIVISA"
        id="PrepagoInput"
        [placeholder]="placeholderValue"
        />
    </div></div>
    </div> 
        <div class="pagoRow " *ngIf="verMonedero && conf.DatosResult.AppConfigJsonPago.TM === '1'">
      <div class="tit-form-group">{{ 'TARJETA_MONEDERO' | translate }}</div>
        <div class="form-group-row">
          <div class="form-group">
            <input
              type="text"
              autocomplete="nope"
              class="form-control TMCodigoForm"
              #monederoInput
              [value]="monederoInput.value"
              formControlName="monedero"
              id="MonederoInput"
              [placeholder]="placeholderValue"
              (focus)="focusValue($event)" 
              (blur)="onBlurValue($event)"
              category="DIVISA" 
            />
          </div>
          <div class="form-group-nocurrency"*ngIf="verTarjetaMonederoCodigo">      
            <input type="text" 
              class="form-control TMCodigoForm"
              autocomplete="nope" 
              formControlName="codigoMonedero" 
              id="CodigoMonederoInput" 
              placeholder="{{ 'CODIGO_TARJETA' | translateV2:'CAPITALIZE' }}"
              readonly
              >
            </div>
        </div>
      </div>
      <div class="pagoRow" *ngIf="verAplazado">
        <div class="tit-form-group">{{ 'APLAZADO' | translate }}</div>
          <div class="form-group-wrap">
            <div class="form-group">
          <input
            type="text"
            autocomplete="nope"
            #aplazadoInput
            [value]="aplazadoInput.value"
            formControlName="aplazado"
            class="form-control"
            id="aplazadoInput"
            [placeholder]="placeholderValue"
            (focus)="focusValue($event)"
            (blur)="onBlurValue($event)"
            category="DIVISA"
          />
          </div></div>
        </div>
   <div class="pagoRow" *ngIf="verTransferencia && conf.DatosResult.AppConfigJsonPago.Transferencia === '1'">
    <div class="tit-form-group">{{ 'TRANSFERENCIA' | translate }}</div>
      <div class="form-group-wrap">
        <div class="form-group">
      <input
        type="text"
        autocomplete="nope"
        [ngClass]="{ 'active-form': isSelected(transferenciaInput) }"
        #transferenciaInput
        [value]="transferenciaInput.value"
        formControlName="transferencia"
        class="form-control"
        id="TransferenciaInput"
        [placeholder]="placeholderValue"
        (focus)="focusTransferenciaValue($event)"
        (blur)="onBlurValue($event)"
        category="DIVISA"
      />
      </div></div>
    </div>
    <div class="pagoRow" *ngIf="verTarjeta">
      <div class="tit-form-group">{{ 'TARJETA' | translate }}</div>
      <div class="form-group-wrap">
        <div
          class="form-group"
          *ngIf="verTarjeta && verWaylet">
          <div class="subtit-form-group">
            <label for="WayletInput">{{ 'WAYLET' | translate }}</label>
          </div>
          <input
            type="text"
            autocomplete="nope"
            formControlName="waylet"
            class="form-control"
            [ngClass]="{ 'active-form': isSelected(wayletInput) }"
            id="WayletInput"
            #wayletInput
            [placeholder]="placeholderValue"
            [value]="wayletInput.value"
            (focus)="focusValue($event)"
            (blur)="onBlurValue($event)"
            category="DIVISA"
          />
        </div>
        <div
          class="form-group"
          *ngIf="verTarjeta && verPinpad && (usandoTieneLectorAlbaran || (conf.DatosResult.AppConfigJsonTarjeta.TarjetaPeriferico === 'D' || conf.DatosResult.AppConfigJsonTarjeta.TarjetaPeriferico === 'DL'))"
        >
          <div class="subtit-form-group">
            <label for="PinpadInput">{{ 'PINPAD' | translate }}</label>
          </div>
          <input
            type="text"
            autocomplete="nope"
            formControlName="pinpad"
            class="form-control"
            [ngClass]="{ 'active-form': isSelected(pinpadInput) }"
            id="PinpadInput"
            #pinpadInput
            [placeholder]="placeholderValue"
            [value]="pinpadInput.value"
            (focus)="focusValue($event)"
            (blur)="onBlurValue($event)"
            category="DIVISA"
          />
        </div>
        <div
          class="form-group"
          *ngIf="verTarjeta && verDatafono && (usandoTieneLectorAlbaran || (conf.DatosResult.AppConfigJsonTarjeta.TarjetaPeriferico === 'L' || conf.DatosResult.AppConfigJsonTarjeta.TarjetaPeriferico === 'DL'))">
          <div class="subtit-form-group">
            <label for="DatafonoInput">{{ 'DATAFONO' | translate }}</label>
          </div>
          <input
            type="text"
            autocomplete="nope"
            #datafonoInput
            formControlName="datafono"
            [ngClass]="{ 'active-form': isSelected(datafonoInput) }"
            class="form-control"
            id="DatafonoInput"
            [placeholder]="placeholderValue"
            [value]="datafonoInput.value"
            (focus)="focusValue($event)"
            (blur)="onBlurValue($event)"
            category="DIVISA"
          />
        </div>
      </div>
    </div>
    <div class="pagoRow" *ngIf="verMetalico && conf.DatosResult.AppConfigJsonPago.Efectivo === '1'">
      <div class="tit-form-group">{{ 'METALICO' | translate }}</div>
        <div class="form-group-wrap">
          <div class="form-group">
        <input
          type="text"
          autocomplete="nope"
          [ngClass]="{ 'active-form': isSelected(metalicoInput) }"
          #metalicoInput
          [value]="metalicoInput.value"
          formControlName="metalico"
          class="form-control"
          id="MetalicoInput"
          [placeholder]="placeholderValue"
          (focus)="focusValue($event)"
          (blur)="onBlurValue($event)"
          category="DIVISA"
        />
        </div></div>
      </div>
      <div class="pagoRow border-top-devolucion" *ngIf="conf.DatosResult.AppConfigJsonPago.Efectivo === '1'">
        <div class="tit-form-group">{{ 'TOTAL_A_DEVOLVER' | translate }}</div>
          <div class="form-group-wrap">
            <div class="form-group">
          <input
            type="text"
            readonly 
            autocomplete="nope"
            [ngClass]="{ 'active-form': isSelected(totalInput) }"
            #totalInput
            [value]="conversor(totalInput.value) | myCurrency: divisaSimboloDecimal : divisaDecimales : divisaPosicion : divisaSimbolo : divisaSimboloDerecha : divisaSimbSeparacionMiles"
            formControlName="total"
            class="form-control"
            id="TotalInput"
            [placeholder]="placeholderValue"
            category="DIVISA"
          />
          </div></div>
        </div>
    <div>
      <div class="pagoRow" *ngIf="conf.DatosResult.AppConfigJsonPago.Efectivo === '1'">
        <div class="tit-form-group">{{ 'EFECTIVO' | translate }}</div>
        <div class="form-group-wrap">
          <div class="form-group">
            <div class="subtit-form-group">
              <label for="RecibidoInput">{{ 'RECIBIDO' | translate }}</label>
            </div>
            <!--[autofocus]="conf.DatosResult.AppConfigJsonPago.Foco=='efectivo'"               (change)="changeValue($event)"-->
            <input
              autofocus
              [autofocus]="conf.DatosResult.AppConfigJsonPago.Foco=='efectivo'"
              type="text"
              autocomplete="nope"
              #recibidoInput
              formControlName="efectivo"
              min="0"
              [ngClass]="{ 'active-form': isSelected(recibidoInput) }"
              class="form-control"
              id="RecibidoInput"
              [placeholder]="placeholderValue"
              (focus)="focusValue($event)"
              category="DIVISA"
            />
          </div>
          <div class="form-group readonly">
            <div class="subtit-form-group">
              <label for="CambioInput">{{ 'CAMBIO' | translate }}</label>
            </div>
            <input
              type="text"
              class="form-control readonly"
              [value]="cambio | myCurrency: divisaSimboloDecimal : divisaDecimales : divisaPosicion : divisaSimbolo : divisaSimboloDerecha : divisaSimbSeparacionMiles"
              id="CambioInput"
              readonly
            />
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="checkboxStyledWrap">
  </div>
</div>
